// extracted by mini-css-extract-plugin
export default {"-large":"eC6p5U9NzZ7JJs0jcRZz","line":"fJp7h2nWgOM_oaTOxqDg","headingContainer":"gpUZdXzr3MydLeQIqM9a"};